module.exports = __webpack_public_path__ + "img/faq-transport.d06ff5c0.svg";